import React from 'react';
import classNames from 'classnames';
import ItemCard from './ItemCard';
import ApprovalInfoPanel from './ApprovalInfoPanel';
import * as format from '../format';
require('./ApprovalItem.scss');
/*

            "id": "d4800d99-6f81-4f4b-9904-f48747d3a405",
            "name": "第一审批人",
            "x": 0.0,
            "y": 0.0,
            "assignes": [
                {
                    "id": 107460817,
                    "name": "anxuenan",
                    "headPortrait": "",
                    "color": "#f79c6f",
                    “approvalState": 0(0未审批  1已审批）
                    "TaskCompleteTime": '43/343',
                    "actionName": '驳回到上一级',
                    "comment": 'dfsdfsdfsdfdsfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsfsdfsdfsdfsdfsdfsd'
                }
            ],
            "assignesNames": 'anxuenan,sss'
            "status": 2,
            "isStart": false,
            "isEnd": false,
            "url": null,
            'startTime': '创建时间',
            'completeTime': '34/342'
        
*/
class ApprovalItem extends React.Component {

	constructor(props) {
		super(props);
        this.handleTapCard = this.handleTapCard.bind(this);
        this.closeInfo = this.closeInfo.bind(this);
        this.setLine = this.setLine.bind(this);
        this.handleSetLine = this.handleSetLine.bind(this);
        this.state = {
            itemHeight: 48
            ,top: 32
            ,showInfo: false
        };
        this.cardInfo = this.formatItemCardData();
	}

    componentDidMount() {
        this.setLine();
    }

    componentWillReceiveProps() {
        this.setLine();
    }

    // 不是未开始和结束 都有时间
    getAdtionDis(info) {
        const { status, isEnd, index } = info;
        return index == 1 ? (20 + 4) : ((isEnd || status == 3) ? 12 : (12 + 20 + 4));
    }

    getIconTop(info) {
        const { status, isEnd } = info;
        return status == 2 ? 24 : (isEnd ? 14 : 26);
    }

    setLine() {
        const currentItem = this.refs.approvalItem;
        const { itemInfo, statusArr,index } = this.props;
        if(currentItem && currentItem.previousSibling) {
            const currentDis = this.getAdtionDis(itemInfo);
            const currentIconTop = this.getIconTop(itemInfo);

            const preItemHeight = currentItem.previousSibling ? currentItem.previousSibling.offsetHeight : 0;
            const preItemDis = this.getAdtionDis(statusArr[index - 1]);
            const preIconTop = this.getIconTop(statusArr[index - 1]);

            const linHeight = currentIconTop + currentDis + preItemHeight - preItemDis - preIconTop;
            const top = currentDis + preItemHeight - preItemDis - preIconTop;
             
            this.setState({ top: top, itemHeight: linHeight });
        }
    }

    handleSetLine() {
        this.setLine();
        this.props.setNextLine(this.props.index);
    }

    closeInfo() {
        this.setState({ showInfo: false });
    }

    handleTapCard() {
        this.setState({ showInfo: true });
    }

    renderTime() {
        const { itemInfo,translation } = this.props;
        const { terminated } = translation;
        let text = format.formatTime((itemInfo.status == 2 || (itemInfo.status == 1 && itemInfo.isStart)) ? itemInfo.startTime : itemInfo.completeTime) || (itemInfo.status != 3 ? '--' : '');
        const subText = itemInfo.status == 6 ? <span>{terminated}</span> : null;
        const isEnd = itemInfo.status == 1 && itemInfo.isEnd;
        text = isEnd ? null : text;
        return (isEnd || itemInfo.status == 3) ? null : <span ref="approvalTime" className={'approval-time time-status-' + itemInfo.status}>{text}{subText}</span>;
    }

    renderIcon(index) {
        const { itemInfo } = this.props;
        let iconName = '';
        switch(itemInfo.status) {
            case 1:
                iconName = (itemInfo.isStart && index == 0) ? 'approval-start' : itemInfo.isEnd ? 'approval-end' : 'approval-complete';
                break;
            case 2:
                iconName = 'approval-progress';
                break;
            case 3:
                iconName = itemInfo.isEnd ? 'approval-end-false' : 'approval-unstart';
                break;
            case 4:
                iconName = 'approval-readmore';
                break;
            case 5:
                iconName = 'm-sys-cancleprocess';
                break;
            case 6:
                iconName = 'approval-discontinue';
                break;
            default:
                iconName = 'm-sys-weikaishi';
        }
        return <span ref="approvalIcon" className={'approval-item-icon ' + iconName} />;
    }

    renderItemLeft() {
        const { itemInfo } = this.props;
        return (<div className="approval-item-left">
                    {this.renderIcon(this.props.index)}
                    {this.props.index != 0 ? <div className={classNames('approval-item-line', 'l-' + itemInfo.status)} style={{ height: this.state.itemHeight + 'px', top: -this.state.top }} /> : null}
                </div>);
    }

    formatItemCardData() {
        const { itemInfo } = this.props;
        const cardInfo = {
            'maiTitle': itemInfo.assignesNames
            ,'subTitle': itemInfo.name
            ,'hasAvatar': itemInfo.assignes.length > 0
            ,'avatar': itemInfo.assignes[0]
            ,'rightTag': itemInfo.assignes[0] && itemInfo.assignes[0].actionName
            ,'botContent': itemInfo.assignes[0] && itemInfo.assignes[0].comment
            ,'assignesNum': itemInfo.assignes.length // 该节点有多少人参与 重复的人也算入计数
            ,'assignesCount': itemInfo.assignesCount // 该节点有多少不重复的人 此值用于展示在会签节点展示总人数
            ,'status': itemInfo.status
            ,'isStart': itemInfo.isStart
            ,'isEnd': itemInfo.isEnd
            ,'activityType': itemInfo.activityType
        };
        return cardInfo;
    }

	render() {
        const { itemInfo,translation } = this.props;
        return (itemInfo.status == 4 ? null
                    :   <div className={'approval-item status-' + itemInfo.status} ref="approvalItem">
                            {this.renderTime()}
                            <div className="approval-item-container">
                                {this.renderItemLeft()}
                                <ItemCard translation={translation} info={this.cardInfo} handleTap={this.handleTapCard} setLine={this.handleSetLine} />
                            </div>
                            {(this.state.showInfo && itemInfo.assignes.length > 1)  ? <ApprovalInfoPanel translation={translation} info={itemInfo} closeInfo={this.closeInfo} /> : null}
                        </div>
        );
    }
}

export default ApprovalItem;


// WEBPACK FOOTER //
// ./src/components/Approval/new/ApprovalItem.js